var _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancelledPinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 38,
    viewBox: "0 0 33 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2861 1.25C24.5573 1.25023 31.3213 8.01492 31.3213 16.2861C31.3212 20.3369 29.8171 24.1089 26.8027 26.9727L17.8281 36.375L17.8223 36.3809L17.8164 36.3877C16.9522 37.2519 15.6202 37.2517 14.7559 36.3877L14.7471 36.3789L5.6123 26.958C2.74996 24.0954 1.25011 20.1875 1.25 16.2861C1.25 8.01478 8.01478 1.25 16.2861 1.25Z",
    fill: "currentColor",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6018 22.3268C22.9661 22.6911 22.9661 23.2375 22.6018 23.6018C22.4196 23.7839 22.2375 23.875 21.9643 23.875C21.6911 23.875 21.5089 23.7839 21.3268 23.6018L16.5 18.775L11.6732 23.6018C11.4911 23.7839 11.3089 23.875 11.0357 23.875C10.7625 23.875 10.5804 23.7839 10.3982 23.6018C10.0339 23.2375 10.0339 22.6911 10.3982 22.3268L15.225 17.5L10.3982 12.6732C10.0339 12.3089 10.0339 11.7625 10.3982 11.3982C10.7625 11.0339 11.3089 11.0339 11.6732 11.3982L16.5 16.225L21.3268 11.3982C21.6911 11.0339 22.2375 11.0339 22.6018 11.3982C22.9661 11.7625 22.9661 12.3089 22.6018 12.6732L17.775 17.5L22.6018 22.3268Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4663_54185",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 12,
    width: 11,
    height: 11
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2457 21.2535C21.529 21.5368 21.529 21.9618 21.2457 22.2452C21.104 22.3868 20.9623 22.4577 20.7498 22.4577C20.5373 22.4577 20.3957 22.3868 20.254 22.2452L16.4998 18.491L12.7457 22.2452C12.604 22.3868 12.4623 22.4577 12.2498 22.4577C12.0373 22.4577 11.8957 22.3868 11.754 22.2452C11.4707 21.9618 11.4707 21.5368 11.754 21.2535L15.5082 17.4993L11.754 13.7452C11.4707 13.4618 11.4707 13.0368 11.754 12.7535C12.0373 12.4702 12.4623 12.4702 12.7457 12.7535L16.4998 16.5077L20.254 12.7535C20.5373 12.4702 20.9623 12.4702 21.2457 12.7535C21.529 13.0368 21.529 13.4618 21.2457 13.7452L17.4915 17.4993L21.2457 21.2535Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4663_54185)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 9H25V26H8V9Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelledPinIcon);
export default __webpack_public_path__ + "static/media/CancelledPinIcon.89cc4c4c373c38f1f8ae1f78acd42245.svg";
export { ForwardRef as ReactComponent };